import {
    DATIQ_INPUT_TOGGLE,
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';
import { ActionCreatorProps, createAction, props } from '@ngrx/store';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq ${DATIQ_INPUT_TOGGLE}] ${name}`;
};
const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const toggledOptionName: string = createActionName('toggled options');
export const toggledOption = createAction(toggledOptionName, defaultProp);
